import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalActions,
  Form
} from '@contently/toolkit';
import { renderPluralized, renderStoriesByTagType } from './csv_helpers';

export const ConfirmationModal = (props) => {
  const {
    isOpen,
    csvData,
    onCancel,
    onConfirm
  } = props;

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <ModalHeader>Are you sure?</ModalHeader>
      <ModalBody>
        {'Are you sure you want to add '}
        <strong>{renderPluralized('tag', csvData.totalTagsToAdd)}</strong>
        {' to '}
        <strong>{renderStoriesByTagType(csvData.validStories, 'tagsToAdd')}</strong>
        {'? This action can not be reversed'}
      </ModalBody>
      <ModalActions>
        <Form.Button onClick={onCancel}>
          Cancel
        </Form.Button>
        <Form.ButtonWithProgress onClick={onConfirm} variant="primary">
          Confirm
        </Form.ButtonWithProgress>
      </ModalActions>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  csvData: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./app/javascript/app/components/admin2/bulk_story_tagging/confirmation_modal.jsx